export const DashboardActions = {
  // Dashboard keys

  GET_DASHBOARD_DEFECT_REPORT_LIST: "GET_DASHBOARD_DEFECT_REPORT_LIST",
  SET_DASHBOARD_DEFECT_REPORT_LIST: "SET_DASHBOARD_DEFECT_REPORT_LIST",

  GET_DASHBOARD_DEFECT_REPORT_ALL_VESSEL_LIST:
    "GET_DASHBOARD_DEFECT_REPORT_ALL_VESSEL_LIST",
  SET_DASHBOARD_DEFECT_REPORT_ALL_VESSEL_LIST:
    "SET_DASHBOARD_DEFECT_REPORT_ALL_VESSEL_LIST",

  GET_DASHBOARD_DEFECT_REPORT_ALL_VESSEL_CATEGORY_LIST:
    "GET_DASHBOARD_DEFECT_REPORT_ALL_VESSEL_CATEGORY_LIST",
  SET_DASHBOARD_DEFECT_REPORT_ALL_VESSEL_CATEGORY_LIST:
    "SET_DASHBOARD_DEFECT_REPORT_ALL_VESSEL_CATEGORY_LIST",

  GET_COMPLETE_CHECK_LIST_COUNT_LIST: "GET_COMPLETE_CHECK_LIST_COUNT_LIST",
  SET_COMPLETE_CHECK_LIST_COUNT_LIST: "SET_COMPLETE_CHECK_LIST_COUNT_LIST",

  GET_DASHBOARD_UNREAD_DEFECT_LIST: "GET_DASHBOARD_UNREAD_DEFECT_LIST",
  SET_DASHBOARD_UNREAD_DEFECT_LIST: "SET_DASHBOARD_UNREAD_DEFECT_LIST",

  // define other action types here
};
